import type { Point } from '../types/point.js';
import { calculateLineBisect } from './calculate-line-bisect.js';

export const getShapeLinesBisect = (shapeVertexes: Point[]) =>
  shapeVertexes.map((point, index) => {
    const isLast = index === shapeVertexes.length - 1;
    const nextPoint = isLast ? shapeVertexes[0] : shapeVertexes[index + 1];

    return calculateLineBisect(point, nextPoint);
  });
